import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, TrendingUp, TrendingDown, Minus } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Watchlist() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  const load = async () => {
    setLoading(true);
    try {
      const d = await api.watchlist();
      setData(d);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="p-6">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h1 className="font-heading font-bold text-2xl tracking-tight" data-testid="watchlist-title">Watchlist Multi-Marchés</h1>
          <p className="text-white/50 text-sm mt-1">Vue synthétique en un coup d'œil. Unité de temps : {data?.timeframe || "—"}.</p>
        </div>
        <button className="btn" onClick={load} data-testid="watchlist-refresh">
          {loading ? <Loader2 size={14} className="animate-spin" /> : "Actualiser"}
        </button>
      </div>

      <div className="panel overflow-hidden">
        <table className="dt" data-testid="watchlist-table">
          <thead>
            <tr>
              <th>Actif</th>
              <th>Prix</th>
              <th>Tendance actuelle</th>
              <th>Tendance future</th>
              <th>Signal</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading && !data && (
              <tr><td colSpan={6} className="text-center text-white/40 py-10">Chargement…</td></tr>
            )}
            {(data?.items || []).map((it) => (
              <tr key={it.symbol} className="cursor-pointer" onClick={() => nav("/", { state: { symbol: it.symbol } })}>
                <td className="font-medium">{it.symbol}</td>
                <td className="font-mono">{it.price?.toFixed?.(5) ?? "—"}</td>
                <td><TrendChip data={it.trend_current} /></td>
                <td><TrendChip data={it.trend_future} /></td>
                <td>
                  {it.has_signal ? (
                    <span className={`chip ${it.signal_direction === "ACHAT" ? "chip-up" : "chip-down"}`}>
                      {it.signal_direction} · {it.signal_confidence}%
                    </span>
                  ) : (
                    <span className="text-white/40 text-xs">—</span>
                  )}
                </td>
                <td className="text-right text-[10px] uppercase text-white/40">{it.source}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function TrendChip({ data }) {
  if (!data) return <span className="text-white/40 text-xs">—</span>;
  const Icon = data.label === "Haussière" ? TrendingUp : data.label === "Baissière" ? TrendingDown : Minus;
  const cls = data.label === "Haussière" ? "chip-up" : data.label === "Baissière" ? "chip-down" : "chip-neutral";
  return (
    <span className={`chip ${cls}`}>
      <Icon size={11} /> {data.label} · {data.confidence}%
    </span>
  );
}
